<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import formTipoProduto from '@/src/components/form-tipo-produto.vue'

import TipoProduto from '@/src/services/tipo-produto'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formTipoProduto },
  data() {
    return {
      mostraForm: true,
      tipoProdutoEdit: {},
      tipos_produto: [],
      tipoProdutoFields: [
        {
          key: 'id_tipo_produto',
          label: 'ID',
          class: 'size-col-20',
        },
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idProduto: '',
    }
  },
  computed: {
    rows() {
      return this.tipos_produto.length
    },
  },

  watch: {},
  mounted() {
    this.listar()
  },
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      TipoProduto.listar(token).then((resposta) => {
        this.tipos_produto = resposta.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    editRegister(empresa) {
      this.tipoProdutoEdit = empresa
      this.mostraForm = false
    },
    cadastra() {
      if (this.tipoProdutoEdit) {
        this.tipoProdutoEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idProduto = id
    },
    Deletar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      TipoProduto.deletar(token, this.idProduto)
        .then((resposta) => {
          this.listar()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idProduto = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Classe do produto</div>
            <div class="subTitulo"
              >Visualize, edite e cadastre novos classe do produto na
              plataforma.</div
            >
          </div>
          <div class="col-md-1 cadastra">
            <button class="btn btn-webreceita" @click="cadastra">
              <span v-if="mostraForm">Novo</span>
              <span v-else>Lista</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
      </div>
      <div>
        <div v-if="mostraForm">
          <b-table
            striped
            hover
            fixed
            responsive="sm"
            borderless
            bordered
            outlined
            small
            :items="tipos_produto"
            :fields="tipoProdutoFields"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <button
                  v-b-tooltip.hover
                  title="Editar"
                  type="button"
                  class="btn btn-light"
                  @click="editRegister(row.item)"
                >
                  <i class="uil uil-edit"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Deletar"
                  type="button"
                  class="btn btn-light"
                  @click="modalDelete(row.item.id_unidade)"
                >
                  <i class="uil uil-trash-alt"></i>
                </button>
              </div>
            </template>
            <template v-slot:cell(ativo)="row">
              {{ row.item.ativo ? 'Sim' : 'Não' }}
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>

        <div v-else>
          <formTipoProduto :tipo_produto="tipoProdutoEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>